import { getPath } from '@/router/common'
const baseUrl = {
  title: '保险',
  path: 'WTTX'
}

export default [
  {
    path: getPath('NewlqStatement', baseUrl),
    name: 'NewlqStatement',
    component: () =>
      import(
        /* webpackChunkName: "lqStatement" */ '@/views/wTTX/lqStatement/index.vue'
      ),
    meta: {
      title: '声明'
    }
  },
  {
    path: getPath('yckInfo', baseUrl),
    name: 'yckInfo',
    component: () =>
      import(
        /* webpackChunkName: "yckInfo" */ '@/views/wTTX/yckInfo/index.vue'
      ),
    meta: {
      title: '余额'
    }
  },
  {
    path: getPath('GetInsurerOrdList', baseUrl),
    name: 'GetInsurerOrdList',
    component: () =>
      import(
        /* webpackChunkName: "GetInsurerOrdList" */ '@/views/wTTX/getInsurerOrdList/index.vue'
      ),
    meta: {
      title: '订单管理'
    }
  },
  {
    path: getPath('CooperativeCarrier', baseUrl),
    name: 'CooperativeCarrier',
    component: () =>
      import(
        /* webpackChunkName: "CooperativeCarrier" */ '@/views/wTTX/cooperativeCarrier/index.vue'
      ),
    meta: {
      title: '申请承运商'
    }
  },
  {
    path: getPath('ApplicationRecord', baseUrl),
    name: 'ApplicationRecord',
    component: () =>
      import(
        /* webpackChunkName: "ApplicationRecord" */ '@/views/wTTX/applicationRecord/index.vue'
      ),
    meta: {
      title: '申请记录'
    }
  },
  {
    path: getPath('CarrierInformation', baseUrl),
    name: 'CarrierInformation',
    component: () =>
      import(
        /* webpackChunkName: "CarrierInformation" */ '@/views/wTTX/carrierInformation/index.vue'
      ),
    meta: {
      title: '承运商信息'
    }
  },
  {
    path: getPath('OrderHistory', baseUrl),
    name: 'OrderHistory',
    component: () =>
      import(
        /* webpackChunkName: "OrderHistory" */ '@/views/wTTX/orderHistory/index.vue'
      ),
    meta: {
      title: '订单记录'
    }
  },
  {
    path: getPath('getOrder_Batch_detail', baseUrl),
    name: 'getOrder_Batch_detail',
    component: () =>
      import(
        /* webpackChunkName: "OrderHistory" */ '@/views/wTTX/orderHistory/getOrder_Batch_detail.vue'
      ),
    meta: {
      title: '整车明细'
    }
  },
  {
    path: getPath('CompanyDoc', baseUrl),
    name: 'CompanyDoc',
    component: () => import(/* webpackChunkName: "CompanyDoc" */ '@/views/wTTX/companyDoc/index.vue'),
    meta: {
      title: '物通天下承运公司档案'
    }
  },
  {
    path: getPath('DocModify', baseUrl),
    name: 'DocModify',
    component: () => import(/* webpackChunkName: "DocModify" */ '@/views/wTTX/docModify/index.vue'),
    meta: {
      title: '到站信息编辑'
    }
  },
  {
    path: getPath('InsureTarget', baseUrl),
    name: 'InsureTarget',
    component: () => import(/* webpackChunkName: "insureTarget" */ '@/views/wTTX/insureTarget/index.vue'),
    meta: {
      title: '投保'
    }
  },
  {
    path: getPath('pushRecord', baseUrl),
    name: 'PushRecord',
    component: () => import(/* webpackChunkName: "pushRecord" */ '@/views/wTTX/pushRecord/index.vue'),
    meta: {
      title: '推单记录'
    }
  },
  {
    path: getPath('UpdateInsure', baseUrl),
    name: 'UpdateInsure',
    component: () => import(/* webpackChunkName: "insureTarget" */ '@/views/wTTX/updateInsure/index.vue'),
    meta: {
      title: '更新投保'
    }
  },
  // 在现有路由配置中添加以下路由
  {
    path: getPath('wholeCarAuditGrid', baseUrl),
    name: 'WholeCarAuditGrid',
    component: () =>
      import(
        /* webpackChunkName: "WholeCarAuditGrid" */ '@/views/wTTX/pushRecord/wholeCarAuditGrid.vue'
      ),
    meta: {
      title: '整车费用确认'
    }
  },
]
